import { Box, Button } from '@material-ui/core';
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

import { useConfigContext } from '../../../../contexts/ConfigContext/ConfigContext';
import { useBreadCrumbs } from '../../../../hooks/useBreadCrumbs';
import { useScreen } from '../../../../hooks/useScreen';
import { Font } from '../../../shared/components/Font';
import { Text } from '../../../shared/components/Text';

export function BreadCrumbsNav() {
  const {
    state: { currentLayout },
  } = useConfigContext();

  const { isMobile } = useScreen();
  const { breadCrumbs } = useBreadCrumbs(currentLayout);

  const chevron = (
    <span className="material-icons-outlined" style={{ fontSize: '17px', verticalAlign: 'text-top', opacity: 0.5 }}>
      chevron_right
    </span>
  );

  const isKeyLastNode = (key) => key === breadCrumbs.length - 1;

  const commonHiderStyle = {
    transition: 'all 0.1s ease, max-width 3s linear, opacity 0.4s ease',
    overflow: 'hidden',
    height: '18px',
  };

  const hiddenStyle = {
    ...commonHiderStyle,
    opacity: 0,
    maxWidth: '0px',
  } as React.CSSProperties;

  const shownStyle = {
    ...commonHiderStyle,
    opacity: 1,
    transition: 'all 0.1s ease, max-width 0.5s linear, opacity 0.5s ease 0.3s',
    maxWidth: '350px',
  } as React.CSSProperties;

  return (
    <Box display="flex" alignItems="center" id={'breadcrumbs'} color="text.secondary">
      {breadCrumbs.map((breadCrumb, key) => (
        <Fragment key={key}>
          <Link to={`${breadCrumb.linkTo}`}>
            <Button
              variant={'text'}
              style={{
                marginLeft: key === 0 ? '-6px' : '0',
                textAlign: 'left',
              }}
            >
              <Font variant={isMobile ? 'caption' : 'body2'} color={'textSecondary'}>
                <Box display={'flex'}>
                  <Box>
                    {breadCrumb.name !== '' ? (
                      <Box display={'flex'} alignItems={'center'} style={breadCrumb.name ? shownStyle : hiddenStyle}>
                        {breadCrumb.iconName && (
                          <i
                            className="material-icons-outlined"
                            style={{ verticalAlign: 'text-top', fontSize: '16px', margin: '-2px 4px 0 2px' }}
                          >
                            {breadCrumb.iconName}
                          </i>
                        )}
                        {breadCrumb.name}
                      </Box>
                    ) : (
                      <Box
                        display={'flex'}
                        alignItems={'center'}
                        style={breadCrumb.name ? { ...hiddenStyle } : { ...shownStyle }}
                      >
                        <Text tId={breadCrumb.titleTextId || '...'} />
                      </Box>
                    )}
                  </Box>
                </Box>
              </Font>
            </Button>
          </Link>
          {!isKeyLastNode(key) && chevron}
        </Fragment>
      ))}
    </Box>
  );
}
